/* Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. */

// Validate Email Format
export function validateEmailFormat(email: string): boolean {
	const regExp =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return regExp.test(email);
}

// This password validation, can be removed when firebase package is updated to 10.2.0 or higher
// replace by firebase/auth validatePassword()
/**
 * Validate Password Format
 * Password must contain:
 * at least 10 characters,
 * at least one uppercase letter,
 * one lowercase letter,
 * and one special character.
 */
export function validatePasswordFormat(password: string): boolean {
	const regExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{10,}$/;
	return regExp.test(password);
}
